import { CANONICAL_ROOT_URL } from '../../constants/constants';
import { isDevelopment } from '../environment/isDevelopment';
import { isTesting } from '../environment/isTesting';

export const getValidatedMetaLink = (link: string): string => {
  const absoluteURL = link.startsWith('http');
  const validatedLink = absoluteURL ? link : `${CANONICAL_ROOT_URL}${link}`;
  if (absoluteURL && !isDevelopment() && !isTesting() && !validatedLink.includes('https://')) {
    throw new Error(`MetaTags link defined as an unsecure URL: ${validatedLink}`);
  }
  return validatedLink;
};
